/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 5fed402df411
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * Sort direction.
 */
export const DirectionEnum = {
  Asc: "asc",
  Desc: "desc",
} as const;
/**
 * Sort direction.
 */
export type DirectionEnum = ClosedEnum<typeof DirectionEnum>;

export const DirectionEnum$zodSchema = z.enum([
  "asc",
  "desc",
]).describe("Sort direction.");
